import Cache from 'admin/editor/cache';
import { debounce } from 'vendor/lodash.debounce';

export default class AlertElement {
  constructor(options) {
    this.learnEditor = options.editor;
    this.savedContent = null;
    this.savedColor = null;
    this.activeElementId = null;
    this.activePosition = null;

    this.cache = new Cache('alert');

    this.init();
  }

  init() {
    const ua = navigator.userAgent,
      action = (ua.match(/iPad/i)) ? "touchstart" : "click";

    $(document).on(action, '.add-build-alert', this.newElement.bind(this));
    $(document).on(action, '.submit-build-alert', this.submitElement.bind(this));
    $(document).on(action, '.cancel-build-alert', this.cancelElement.bind(this));
    $(document).on(action, '.delete-build-alert', this.deleteElement.bind(this));
    $(document).on(action, '.build-alert', this.editElement.bind(this));
  }

  shouldShowButton() {
    return true;
  }

  addButtonTemplate() {
    return '<a class="add-build-alert" href="#"><i class="fa fa-exclamation-circle"></i>Alert</a>';
  }

  newElement(event) {
    event.preventDefault();

    let link = $(event.currentTarget);

    //only one editor should be enabled at a time
    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    this.savedContent = null;
    this.savedColor = null;

    const cachedContent = this.cache.get('content');
    const cachedColor = this.cache.get('color');

    this.insertAlert(link.closest('.button-bar, .bottom-button-bar'), cachedContent, cachedColor);
    this.learnEditor.editing();
  }

  async submitElement(event) {
    event.preventDefault();
    const $element = $(event.currentTarget).closest('.build-alert-wrapper');

    const content = await this.processContent($('.build-input').val());

    const color = $('.editor-add-colors .active').text().toLowerCase();

    this.savedContent = null;
    this.savedColor = null;
    this.addAlert($element, content, color, this.activeElementId, this.activePosition);
    this.activeElementId = "";
    this.activePosition = "";
    this.learnEditor.save_page("Before Added Alert Element");
  }

  async processContent(value) {
    return $.post('/elements/markdown.json', { markdown: value })
            .then(response => ({ text: value, html: response.content }))
  }

  editElement(event) {
    event.preventDefault();
    //or if an editor is already present
    if(this.learnEditor.is_editor_enabled()) { //only one editor should be enabled at a time
      return;
    }

    let $element = $(event.currentTarget);

    const content = {
      text: $(".alert-content", $element).data('content'),
      html: $(".alert-content", $element).html(),
    }

    $('.alert', $element).find('.fa-exclamation-circle, .icon-exclamation-sign').remove();
    content.text = content.text ? content.text : content.html;

    let color = $element.attr('class').match(/alert-(danger|warning|primary|info)/);
    if (color) {
      color = color[1];
    }
    const cachedContent = this.cache.get('content');
    const cachedColor = this.cache.get('color');

    //backup the text, save it in case of cancelling
    this.savedContent = content;
    this.savedColor = color;
    this.activeElementId = $element.attr('id');
    this.activePosition = $element.data('position');
    this.insertAlert($element, cachedContent || content, cachedColor || color);
    this.learnEditor.centerInView($('.build-alert-wrapper'));
    this.learnEditor.editing();
  }

  cancelElement(event) {
    event.preventDefault();

    let $element = $(event.currentTarget);

    //restore with global saved text
    this.addAlert($element.closest('.build-alert-wrapper'),
                  this.savedContent,
                  this.savedColor,
                  this.activeElementId,
                  this.activePosition);
    this.activeElementId = "";
    this.activePosition = "";

    this.learnEditor.finishEditing();
    this.cache.delete();
  }

  deleteElement(event) {
    event.preventDefault();

    let $element = $(event.currentTarget);

    if (!confirm("Confirm deletion of this element.")) {
      return;
    }

    $element.closest('.build-alert-wrapper').remove();

    this.savedContent = null;
    this.savedColor = null;
    this.activeElementId = "";
    this.activePosition = "";

    this.learnEditor.save_page("Before Deleted Alert Element");

    this.cache.delete();
  }

  insertAlert($element, content, color) {
    const buildText = this.buildAlert(content, color);

    $element.hide();
    let $build_text = $(buildText).hide();
    $element.replaceWith($build_text);
    $('.build-alert-wrapper').show();

    this.watchState($build_text);
    this.learnEditor.centerInView($('.build-alert-wrapper'));
  }

  watchState($element) {
    var saveState = function(event) {
      const content = { text: $('.build-input').val() };
      const color = $('.editor-add-colors .active').text().toLowerCase();
      this.cache.save({ content: content, color: color });
    }

    $element.find('.build-input').on('keyup', debounce(saveState.bind(this), 500));
    $element.find('.editor-add-colors button').on('click', debounce(saveState.bind(this), 500));
  }

  buildAlert(content, color) {
    let text = content?.text || "";
    text = text.replace(/'/g, "&#39;").trim();
    let colorClass = "";

    let buildText =
      `<div class='row-fluid build-alert-wrapper'>
        <label>Choose alert type</label>
        <div class='editor-add-colors btn-group'>
          <button type='button' class='btn-danger active editor-button'>Danger</button>
          <button type='button' class='btn-primary editor-button'>Primary</button>
          <button type='button' class='btn-info editor-button'>Info</button>
          <button type='button' class='btn-warning editor-button'>Warning</button>
          <div class='clear'></div>
        </div>
        <label for='alert-content'>Enter alert text</label>
        <textarea name='alert-content' class='build-input span12' style='display=block;'>${text}</textarea>
        <p class="help">Markdown is supported in the alert text.</p>
        <div class="editor-buttons">
          <button class='delete-build-alert delete'>Delete</button>
          <button class='cancel-build-alert cancel'>Cancel</button>
          <button class='submit-build-alert save'>Save</button>
        </div>
      </div>`;

    let $buildText = $(buildText);

    if (color) {
      colorClass = ".btn-" + color;
      $('.editor-add-colors button', $buildText).removeClass('active');
      $(colorClass, $buildText).addClass('active');
    }

    return $buildText;
  }

  escapeHtml = (html) => {
    return html.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#039;');
  }

  addAlert($element, content, color, id, position) {
    let alertHtml =
      `<div id='${id || ''}' class='element row-fluid alert-element build-alert' data-position='${position}'>
        <i class='fa fa-exclamation-circle'></i>
        <span class='alert-content' data-content="${this.escapeHtml(content.text)}">${content.html}</span>
      </div>`;

    let $alertHtml = $(alertHtml);

    if (color) {
      color = 'alert-' + color;
    }
    $alertHtml.addClass(color);

    if (content) {
      $element.replaceWith($alertHtml);
    } else {
      $element.remove();
    }
  }
}
